import React from 'react';
import { css } from 'linaria';
import { breakpointLargeTablet } from 'common/constants'; // 1023

import { breakpointSmallTablet } from 'common/constants'; // 839

import { breakpointLargeHandset } from 'common/constants'; // 599

import { breakpointSmallHandset } from 'common/constants'; // 399

import { useTranslation } from 'next-i18next';
const wrapper = "w1p48pk0";
export function CallOutBrand() {
  const {
    t
  } = useTranslation();
  return <div className={`${wrapper} brandingMessage`}>
      <div className="brandBlock">
        <aside>
          {t('call-out:interesting-stories', 'Interesting stories for interesting people')}
        </aside>
        <blockquote>
          <span className="copy">
            <svg className="zigzag" xmlns="http://www.w3.org/2000/svg" width="192" height="13" fill="none">
              <defs />
              <path className="squiggle" strokeMiterlimit="10" strokeWidth="2" d="M0 1.306c13.72 0 13.72 9.91 27.42 9.91 13.7 0 13.7-9.91 27.42-9.91 13.72 0 13.72 9.91 27.42 9.91 13.72 0 13.72-9.91 27.44-9.91s13.72 9.91 27.42 9.91c13.72 0 13.72-9.91 27.44-9.91s13.72 9.91 27.44 9.91" />
            </svg>
            {t('call-out:pocket-is-where', 'Pocket is where you’ll find fascinating stories from all across the web, right here in one place.')}
          </span>
        </blockquote>
      </div>
    </div>;
}

require("./call-out-brand.linaria.module.css!=!../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./call-out-brand.js");